import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialModule} from '../material.module';
import {ReactiveFormsModule} from '@angular/forms';
import {SegmentsMultiShareComponent} from './share/segments-multi-share.component';
import {SegmentModule} from '../segment/segment.module';
import {SharedModule} from '../shared.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MultishareHistoryModule} from './multishare-history/multishare-history.module';
import {MatButtonToggleModule} from '@angular/material/button-toggle';

@NgModule({
  declarations: [
    SegmentsMultiShareComponent
  ],
  exports: [
    SegmentsMultiShareComponent
  ],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        SegmentModule,
        SharedModule,
        MatProgressSpinnerModule,
        MultishareHistoryModule,
        MatButtonToggleModule,
    ]
})
export class SegmentMultiShareModule {
}
